import { z } from 'zod';

import { ConditionViolationType } from './condition-violation-status';

// Each individual measurement in time
export const TimeseriesPointSchema = z.object({
  timestamp: z.date(),
  count: z.number(),
});
export type TimeseriesPoint = z.infer<typeof TimeseriesPointSchema>;

export const ConditionsViolationTimeseriesDataSchema = z.object({
  id: z.string(),
  groupFullId: z.string(),
  topFullId: z.string(),
  unitFullId: z.string().optional(),
  fullFrontendId: z.string(),
  description: z.nativeEnum(ConditionViolationType),
  timeseries: z.array(TimeseriesPointSchema),
});
export type ConditionsViolationTimeseriesData = z.infer<
  typeof ConditionsViolationTimeseriesDataSchema
>;
